import React from 'react';
import { motion } from 'framer-motion';
import MotionSection from '../components/ui/MotionSection';

const Terms = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen pt-20"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <MotionSection className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4">Terms of Service</h1>
          <p className="text-light/60">Last updated: December 2024</p>
        </MotionSection>

        <MotionSection className="prose prose-invert max-w-none">
          <div className="space-y-8">
            <section>
              <h2 className="text-2xl font-bold mb-4">Acceptance of Terms</h2>
              <p className="text-light/80">
                By accessing and using ColdMail AI, you accept and agree to be bound by the 
                terms and provision of this agreement. If you do not agree to abide by the 
                above, please do not use this service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Use License</h2>
              <p className="text-light/80 mb-4">
                Permission is granted to temporarily use ColdMail AI for personal and 
                commercial email generation purposes. This is the grant of a license, not a 
                transfer of title, and under this license you may not:
              </p>
              <ul className="list-disc list-inside space-y-2 text-light/80">
                <li>Modify or copy the materials</li>
                <li>Use the materials for any commercial purpose without proper licensing</li>
                <li>Attempt to reverse engineer any software</li>
                <li>Remove any copyright or other proprietary notations</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Fair Usage Policy</h2>
              <p className="text-light/80">
                Our "unlimited" plans are subject to fair usage policies. We reserve the right 
                to limit usage that significantly impacts our service or other users' experience. 
                Typical usage patterns are well within acceptable limits.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Content Responsibility</h2>
              <p className="text-light/80">
                You are responsible for the content you generate and send using our service. 
                ColdMail AI should not be used for spam, harassment, or any illegal activities. 
                We reserve the right to terminate accounts that violate these terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Payment Terms</h2>
              <p className="text-light/80 mb-4">
                Subscription fees are billed in advance on a monthly or annual basis. 
                You can cancel your subscription at any time. Refunds are available within 
                30 days of initial purchase.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Limitation of Liability</h2>
              <p className="text-light/80">
                In no event shall ColdMail AI or its suppliers be liable for any damages 
                (including, without limitation, damages for loss of data or profit, or due to 
                business interruption) arising out of the use or inability to use the service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Modifications</h2>
              <p className="text-light/80">
                ColdMail AI may revise these terms of service at any time without notice. 
                By using this service, you are agreeing to be bound by the then current 
                version of these terms of service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Contact Information</h2>
              <p className="text-light/80">
                If you have any questions about these Terms of Service, please contact us at{' '}
                <a href="mailto:legal@coldmail.ai" className="text-primary hover:underline">
                  legal@coldmail.ai
                </a>
              </p>
            </section>
          </div>
        </MotionSection>
      </div>
    </motion.div>
  );
};

export default Terms;